import * as React from "react";
import Select from "components/common/Select";
import useWatchlistsV2 from "watchlist/hooks/useWatchlistsV2";
const WatchlistSelector = ({ id, value, onChange, filterType = void 0 }) => {
  const { watchlists, isLoading } = useWatchlistsV2();
  const options = watchlists.filter((w) => !filterType || w.type === filterType).map((w) => ({ value: w.id, label: w.name }));
  return /* @__PURE__ */ React.createElement(
    Select,
    {
      inputId: id,
      placeholder: "Select a watchlist...",
      onChange,
      value,
      options,
      isLoading
    }
  );
};
export default WatchlistSelector;
